/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import { Identification } from '@umati/dashboard-common';
import { IMachineData, IMachineVerboseData } from '@umati/dashboard-types';
import React, { ReactElement } from 'react';
import { Card } from 'react-bootstrap';

interface IHardCodedDetailDivProps {
  data: IMachineData | IMachineVerboseData;
}

export default function HardCodedDetailDiv(props: IHardCodedDetailDivProps): ReactElement {
  return (
    <Card className="mb-4">
      <Card.Header>
        <h3>Identification</h3>
      </Card.Header>
      <Card.Body>
        <Identification {...props.data} />
      </Card.Body>
    </Card>
  );
}
